export default __webpack_public_path__ + "static/media/Onboarding-1.cdc05bca.jpg";